import axios from 'axios';
import { FinalTermType } from '../app';
import { mapFinalTermTypeToDto } from '../helpers';

export const submitFinalTerms = async (token: string, fields: FinalTermType, forceWarning: boolean) => {
  const { finalTerm, file } = mapFinalTermTypeToDto(fields);

  const data = new FormData();

  const finalTermBody = JSON.stringify(finalTerm);

  data.set('finalTerm', new Blob([finalTermBody], { type: 'application/json' }));
  data.set('file', file, file.name);

  const config = {
    headers: {
      'content-type': 'multipart/form-data',
      'g-token': token,
    },
  };

  await axios.post(`/final-terms-api/api/v1/final-terms?forceWarning=${forceWarning}`, data, config);
};
